/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class ReviewsReceivedReviewDetailsRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'reviews.received.review.details',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ReviewsReceivedReviewDetailsRoute);
